/**
 * **タイムラインの帯の色**（純関数）。役割で色を分ける（ユーザー要望 2026-10-01）:
 *
 * | 役割 | 色 |
 * |---|---|
 * | motion（カードを動かす。型の id が `<状況>_motion`） | 暗めの赤 |
 * | effect（強調の演出） | 青 |
 *
 * motion の**絵**がカードの濃さに合わせて薄くなるのは舞台の側（`duelEditor/stage/EffectLayer.js`）。帯の色は変えない。
 */
import { roleOfType } from '../duelEditor/core/effect';

export const MOTION_COLOR = '#8e3232';
export const EFFECT_COLOR = '#2e68b2';

/** @returns `{ role, background }` */
export function clipLook(type) {
  const { role } = roleOfType(type);
  return { role, background: role === 'motion' ? MOTION_COLOR : EFFECT_COLOR };
}
